// import React from 'react';
import { createBrowserRouter } from "react-router-dom";
// import MasterLayout from "../layouts/MasterLayout";
import PublicRoutes from "./PublicRoutes";
import LoginRoutes from "./LoginRoutes";
import RFSICRoutes from "./RFSICRoutes";

const router = createBrowserRouter([
  {
    path: "/",
    // element: <MasterLayout />,
    children: [
      PublicRoutes,
      ...LoginRoutes,
      RFSICRoutes,
    ],
  },
]);

export default router;
